import { render, staticRenderFns } from "./permissionPicker.vue?vue&type=template&id=16dd5ec5&scoped=true"
import script from "./permissionPicker.vue?vue&type=script&lang=js"
export * from "./permissionPicker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16dd5ec5",
  null
  
)

export default component.exports